// import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
// import DashboardView from "../DashboardView";
// import { Row, Col, Button, Modal, Input, message } from "antd";
// import { Link } from "react-router-dom";
// import GroupList from "./GroupList";
// import AddBoardGroup from "../../components/BoardGoups/AddBoardGroup";
// import jwt from "jsonwebtoken";
// import { useSelector, useDispatch } from "react-redux";
// import { resetGoupSavingState, getGroupsAsync, resetGroupDeletingState } from "../../redux/boardSlice";
// import Loading from "../../components/common/Spinners/Loading";
// import NoPermission from "../../components/common/NoPermission";

// const { REACT_APP_OrgRegistryApi, REACT_APP_OrgjwtAud, REACT_APP_OrgjwtIss, REACT_APP_OrgjwtPrivate } = process.env;

// export default function Groups() {
//   const dispatch = useDispatch();
//   const [isNewGropModalVisible, setNewGropModalVisibility] = useState(false);
//   const [usersList, setUsers] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState({});
//   const [isEdit, setEdit] = useState(false);
//   const [isViewOnly, setIsViewOnly] = useState(false);
//   const [isEditGroup, setIsEditGroup] = useState(false);
//   const [data, setData] = useState([]);

//   const boards = useSelector((state) => state.boards);
//   const user = useSelector((state) => state.user);

//   const addBoardGroupRef = useRef();

//   console.log("Groups data", boards);

//   const onSearchGroups = (value) => {
//     console.log("Search Value ===>>", value);

//     if (!value || value.trim() === "") {
//       return fetchGroups();
//     }

//     const searchTerm = value.toLowerCase().trim();

//     const filteredData =
//       boards.groups?.filter((item) => {
//         const title = (item.title || "").toLowerCase();
//         const groupType = (item.groupType || "").toLowerCase();

//         return title.includes(searchTerm) || groupType.includes(searchTerm);
//       }) || [];

//     const sortedData = filteredData.sort((a, b) => {
//       const titleA = (a.title || "").toLowerCase();
//       const titleB = (b.title || "").toLowerCase();

//       if (titleA < titleB) return -1;
//       if (titleA > titleB) return 1;
//       return 0;
//     });

//     setData(sortedData);
//   };

//   const handleGroupSelect = (id) => {
//     setSelectedGroup(boards.groups.find((group) => group._id === id));
//   };

//   const fetchGroups = useCallback(() => {
//     dispatch(getGroupsAsync(user?.user?.accessToken));
//     dispatch(resetGoupSavingState());
//   }, [dispatch]);

//   useEffect(() => {
//     fetchGroups();
//   }, [fetchGroups]);

//   useEffect(() => {
//     if (boards.groups) {
//       setData(() => [...boards.groups]);
//     }
//   }, [boards.groups]);

//   useEffect(() => {
//     if (boards.groupDeletingState === "success") {
//       message.success("Group has been successfully deleted!");
//       dispatch(resetGroupDeletingState());
//     }
//   }, [boards.groupDeletingState, dispatch]);

//   useEffect(() => {
//     if (boards.groupSavingState === "success") {
//       fetchGroups();
//     }
//   }, [boards.groupSavingState, fetchGroups]);

//   // useEffect(() => {
//   //     // if(user.currentAppPermissions.)
//   //     if(user.currentAppPermissions && user.currentAppPermissions.indexOf("CreateGroup")===-1) {
//   //         history.push('/')
//   //     }
//   // }, [user.currentAppPermissions])

//   const GetUserDetails = async (UserDetails) => {
//     const timestamp = Math.floor(Date.now() / 1000) + 1000;

//     var payload = {
//       aud: REACT_APP_OrgjwtAud,
//       exp: timestamp,
//       iss: REACT_APP_OrgjwtIss,
//       usertoken: localStorage.getItem("accessToken"),
//     };

//     var signOptions = {
//       algorithm: "RS256",
//     };

//     var privateKey = REACT_APP_OrgjwtPrivate;
//     var token = jwt.sign(payload, privateKey.replace(/\\n/g, "\n"), signOptions);

//     const result = [];

//     const requestOptions2 = {
//       method: "GET",
//       headers: {
//         "Access-Control-Allow-Origin": "*",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ` + token,
//       },
//     };

//     //  console.log(UserDetails);

//     return await fetch(REACT_APP_OrgRegistryApi + "user/" + UserDetails.UserID, requestOptions2)
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.Status) {
//           result.push({ ...UserDetails, UserDetails: data.Result });
//           return result[0];
//         }
//       })
//       .catch((error) => {
//         //window.location.href="/login/logout"
//       });
//   };

//   useEffect(() => {
//     const timestamp = Math.floor(Date.now() / 1000) + 1000;
//     var payload = {
//       aud: REACT_APP_OrgjwtAud,
//       exp: timestamp,
//       iss: REACT_APP_OrgjwtIss,
//       usertoken: localStorage.getItem("accessToken"),
//     };

//     var signOptions = {
//       algorithm: "RS256",
//     };

//     var privateKey = REACT_APP_OrgjwtPrivate;
//     var token = jwt.sign(payload, privateKey.replace(/\\n/g, "\n"), signOptions);

//     const vrequestOptions = {
//       method: "GET",
//       headers: {
//         "Access-Control-Allow-Origin": "*",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ` + token,
//       },
//     };

//     fetch(`${REACT_APP_OrgRegistryApi}registeredusers/` + localStorage.getItem("orgID"), vrequestOptions)
//       .then((lresponse) => lresponse.json())
//       .then(async (odata) => {
//         //  console.log(odata);
//         const users = await Promise.all(odata.Result.map(async (UserID) => await GetUserDetails(UserID, odata.Result)));

//         setUsers(users);
//       });
//   }, []);

//   const setModalVisibility = (visibility, isEdit) => {
//     if (!isEdit) {
//       setSelectedGroup({});
//     }
//     setNewGropModalVisibility(visibility);
//     setEdit(isEdit);
//   };

//   const handleSaveGroup = () => {
//     setNewGropModalVisibility(false);
//     fetchGroups();
//   };

//   // if(user.currentAppPermissions && user.currentAppPermissions.indexOf("CreateGroup")===-1) {
//   //     return (
//   //         <DashboardView>
//   //             <NoPermission />
//   //         </DashboardView>
//   //     )
//   // }

//   return (
//     <DashboardView>
//       <div style={{ background: "#F7F7F8" }}>
//         <Row>
//           <Col span={4}>
//             <h2>Groups</h2>
//           </Col>
//           <Col span={2}></Col>
//           <Col span={8}>
//             <Input
//               placeholder="Search Groups By Name or Type"
//               onChange={(e) => onSearchGroups(e.target.value)}
//               style={{ width: "100%" }}
//             />
//           </Col>
//           <Col span={4}></Col>
//           <Col span={6}>
//             <Button type="primary" onClick={() => setModalVisibility(true, false)}>
//               Add New
//             </Button>
//           </Col>
//         </Row>
//         <div style={{ marginTop: "1rem" }}>
//           {boards.groupsStatus === "pending" ? (
//             <Loading />
//           ) : !data.length && boards.groupsStatus === "fulfilled" ? (
//             <div
//               style={{
//                 position: "fixed",
//                 bottom: "50%",
//                 left: "42%",
//               }}
//             >
//               <h3>No Matching Groups Found...</h3>
//             </div>
//           ) : (
//             <GroupList
//               groups={data.sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0))}
//               setNewGropModalVisibility={(value) => setNewGropModalVisibility(value, true)}
//               handleGroupSelect={handleGroupSelect}
//               setIsViewOnly={setIsViewOnly}
//               setIsEditGroup={setIsEditGroup}
//             />
//           )}
//         </div>
//         <Modal
//           title={`${isViewOnly ? "Group Overview" : !isEditGroup && !isViewOnly ? "Add New Group" : "Update Group"}`}
//           visible={isNewGropModalVisible}
//           onOk={() => handleSaveGroup}
//           onCancel={() => {
//             if (addBoardGroupRef.current) {
//               if (selectedGroup && (isEditGroup || isViewOnly)) {
//                 // For edit mode, reset to initial edit values
//                 addBoardGroupRef.current.resetToEditInitialState();
//               } else {
//                 // For new group, reset completely
//                 addBoardGroupRef.current.resetToInitialState();
//               }
//             }
//             setNewGropModalVisibility(false);
//             setIsViewOnly(false);
//             setIsEditGroup(false);
//           }}
//           footer={null}
//           okText="Save Group"
//           width={720}
//         >
//           <AddBoardGroup
//             ref={addBoardGroupRef}
//             users={usersList}
//             handleCloseModal={setNewGropModalVisibility}
//             selectedGroup={selectedGroup}
//             isEdit={isEdit}
//             isViewOnly={isViewOnly}
//           />
//         </Modal>
//       </div>
//     </DashboardView>
//   );
// }

import React, { useCallback, useEffect, useRef, useState } from "react";
import DashboardView from "../DashboardView";
import { Modal, message } from "antd";
import GroupList from "./GroupList";
import AddBoardGroup from "../../components/BoardGoups/AddBoardGroup";
import jwt from "jsonwebtoken";
import { useSelector, useDispatch } from "react-redux";
import { resetGoupSavingState, getGroupsAsync, resetGroupDeletingState } from "../../redux/boardSlice";
// import Loading from "../../components/common/Spinners/Loading"; // replaced by the list's skeletons
import { GROUP_VISIBILITIES, getGroupVisibility, isSpecialUser } from "../../utils/groupVisibility";
import "./Groups.css";

const { REACT_APP_OrgRegistryApi, REACT_APP_OrgjwtAud, REACT_APP_OrgjwtIss, REACT_APP_OrgjwtPrivate } = process.env;

export default function Groups() {
  const dispatch = useDispatch();
  const [isNewGropModalVisible, setNewGropModalVisibility] = useState(false);
  const [usersList, setUsers] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState({});
  const [isEdit, setEdit] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [isEditGroup, setIsEditGroup] = useState(false);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [viewMode, setViewMode] = useState("list");

  const boards = useSelector((state) => state.boards);
  const user = useSelector((state) => state.user);
  const addBoardGroupRef = useRef();

  /* ── Filtering ─────────────────────────────────────────
     The Type column shows visibility (Private / Public / Global) now that group
     type is not captured, so the filter and search match on that instead. */
  const filteredData = (data || []).filter((item) => {
    const matchSearch =
      (item.title || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
      getGroupVisibility(item).includes(searchQuery.toLowerCase());
    const matchType = filterType === "all" || getGroupVisibility(item) === filterType;
    return matchSearch && matchType;
  });

  // Global groups only exist for super users, so only they are offered that filter.
  const uniqueTypes = GROUP_VISIBILITIES.filter((v) => v !== "global" || isSpecialUser());

  /* ── Data fetching ─────────────────────────────────── */
  const fetchGroups = useCallback(() => {
    dispatch(getGroupsAsync(user?.user?.accessToken));
    dispatch(resetGoupSavingState());
  }, [dispatch]);

  useEffect(() => {
    fetchGroups();
  }, [fetchGroups]);

  useEffect(() => {
    if (boards.groups) setData([...boards.groups]);
  }, [boards.groups]);

  useEffect(() => {
    if (boards.groupDeletingState === "success") {
      message.success("Group has been successfully deleted!");
      dispatch(resetGroupDeletingState());
    }
  }, [boards.groupDeletingState, dispatch]);

  useEffect(() => {
    if (boards.groupSavingState === "success") fetchGroups();
  }, [boards.groupSavingState, fetchGroups]);

  /* ── Users fetch ───────────────────────────────────── */
  const GetUserDetails = async (UserDetails) => {
    const timestamp = Math.floor(Date.now() / 1000) + 1000;
    const payload = {
      aud: REACT_APP_OrgjwtAud,
      exp: timestamp,
      iss: REACT_APP_OrgjwtIss,
      usertoken: localStorage.getItem("accessToken"),
    };
    const token = jwt.sign(payload, REACT_APP_OrgjwtPrivate.replace(/\\n/g, "\n"), { algorithm: "RS256" });
    return await fetch(REACT_APP_OrgRegistryApi + "user/" + UserDetails.UserID, {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((d) => {
        if (d.Status) return { ...UserDetails, UserDetails: d.Result };
      })
      .catch(() => {});
  };

  useEffect(() => {
    const timestamp = Math.floor(Date.now() / 1000) + 1000;
    const payload = {
      aud: REACT_APP_OrgjwtAud,
      exp: timestamp,
      iss: REACT_APP_OrgjwtIss,
      usertoken: localStorage.getItem("accessToken"),
    };
    const token = jwt.sign(payload, REACT_APP_OrgjwtPrivate.replace(/\\n/g, "\n"), { algorithm: "RS256" });
    fetch(`${REACT_APP_OrgRegistryApi}registeredusers/${localStorage.getItem("orgID")}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then(async (odata) => {
        const users = await Promise.all(odata.Result.map(async (uid) => await GetUserDetails(uid, odata.Result)));
        setUsers(users);
      });
  }, []);

  /* ── Modal helpers ─────────────────────────────────── */
  const setModalVisibility = (visibility, isEditFlag) => {
    if (!isEditFlag) setSelectedGroup({});
    setNewGropModalVisibility(visibility);
    setEdit(isEditFlag);
  };

  const handleGroupSelect = (id) => {
    setSelectedGroup(boards.groups.find((g) => g._id === id));
  };

  const handleSaveGroup = () => {
    setNewGropModalVisibility(false);
    fetchGroups();
  };

  const handleModalCancel = () => {
    if (addBoardGroupRef.current) {
      if (selectedGroup && (isEditGroup || isViewOnly)) {
        addBoardGroupRef.current.resetToEditInitialState();
      } else {
        addBoardGroupRef.current.resetToInitialState();
      }
    }
    setNewGropModalVisibility(false);
    setIsViewOnly(false);
    setIsEditGroup(false);
  };

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };

  const isLoading = boards.groupsStatus === "pending";
  const sortedData = filteredData.sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0));

  return (
    <DashboardView>
      <div className="grp-shell">
        {/* Header */}
        <div className="grp-header">
          <div className="grp-header-left">
            <h1 className="grp-title">Groups</h1>
            <p className="grp-subtitle">
              {/* "0 groups found" while the fetch is still running reads as an empty
                  result, so the count waits for the data. */}
              {isLoading
                ? "Loading groups…"
                : `${filteredData.length} group${filteredData.length !== 1 ? "s" : ""} found`}
            </p>
          </div>
          <div className="grp-header-right">
            {/* View toggle */}
            <div className="grp-view-toggle">
              <button
                className={`grp-toggle-btn ${viewMode === "list" ? "active" : ""}`}
                onClick={() => handleViewModeChange("list")}
                title="List view"
              >
                <svg viewBox="0 0 16 16" fill="currentColor" width="15" height="15">
                  <rect x="1" y="2" width="14" height="2" rx="1" />
                  <rect x="1" y="7" width="14" height="2" rx="1" />
                  <rect x="1" y="12" width="14" height="2" rx="1" />
                </svg>
              </button>
              <button
                className={`grp-toggle-btn ${viewMode === "grid" ? "active" : ""}`}
                onClick={() => handleViewModeChange("grid")}
                title="Grid view"
              >
                <svg viewBox="0 0 16 16" fill="currentColor" width="15" height="15">
                  <rect x="1" y="1" width="6" height="6" rx="1" />
                  <rect x="9" y="1" width="6" height="6" rx="1" />
                  <rect x="1" y="9" width="6" height="6" rx="1" />
                  <rect x="9" y="9" width="6" height="6" rx="1" />
                </svg>
              </button>
            </div>
            <button className="grp-create-btn" onClick={() => setModalVisibility(true, false)}>
              Add New Group
              <svg viewBox="0 0 16 16" fill="currentColor" width="14" height="14">
                <path d="M8 2a1 1 0 011 1v4h4a1 1 0 010 2H9v4a1 1 0 01-2 0V9H3a1 1 0 010-2h4V3a1 1 0 011-1z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Controls */}
        <div className="grp-controls">
          <select className="grp-select" value={filterType} onChange={(e) => setFilterType(e.target.value)}>
            <option value="all">All Types</option>
            {uniqueTypes.map((t) => (
              <option key={t} value={t}>
                {t.charAt(0).toUpperCase() + t.slice(1)}
              </option>
            ))}
          </select>

          <div className="grp-search-wrap">
            <svg className="grp-search-icon" viewBox="0 0 20 20" fill="none" width="16" height="16">
              <circle cx="8.5" cy="8.5" r="5.5" stroke="#9ca3af" strokeWidth="1.5" />
              <path d="M13 13l3 3" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <input
              className="grp-search-input"
              type="text"
              placeholder="Search groups..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* Content */}
        {/* The list draws its own skeleton rows/cards while the groups are fetched -
            same loading as the Dashboards / Reports, Resources and Schedule Reports
            tables - so the spinner is no longer used. Kept in case we want it back.
            {isLoading ? (
              <div className="grp-loading">
                <Loading />
              </div>
            ) : ...} */}
        {!isLoading && filteredData.length === 0 ? (
          <div className="grp-empty">No matching groups found.</div>
        ) : (
          <GroupList
            groups={sortedData}
            viewMode={viewMode}
            loading={isLoading}
            setNewGropModalVisibility={(value) => setNewGropModalVisibility(value, true)}
            handleGroupSelect={handleGroupSelect}
            setIsViewOnly={setIsViewOnly}
            setIsEditGroup={setIsEditGroup}
          />
        )}

        {/* Modal */}
        <Modal
          title={isViewOnly ? "Group Overview" : !isEditGroup && !isViewOnly ? "Add New Group" : "Update Group"}
          visible={isNewGropModalVisible}
          onOk={handleSaveGroup}
          onCancel={handleModalCancel}
          footer={null}
          okText="Save Group"
          width={600}
          className="add-group-modal"
        >
          <AddBoardGroup
            ref={addBoardGroupRef}
            users={usersList}
            handleCloseModal={handleModalCancel}
            selectedGroup={selectedGroup}
            isEdit={isEdit}
            isViewOnly={isViewOnly}
          />
        </Modal>
      </div>
    </DashboardView>
  );
}
